// @flow

import * as React from 'react';

import { Switch } from '@gandi/ui';

type Props = {
  name: string,
  checked: boolean,
  children: React.Node,
  onChange: (checked: boolean) => Promise<mixed>,
  ...
};

export default function ControlledAsyncSwitch({
  name,
  children,
  checked,
  onChange: onAsyncChange,
  ...extraProps
}: Props): React.Node {
  const [disabled, setDisabled] = React.useState<boolean>(false);

  const handleChange = async (evt: SyntheticInputEvent<>) => {
    setDisabled(true);
    try {
      await onAsyncChange(evt.target.checked);
    } finally {
      setDisabled(false);
    }
  };

  return (
    // $FlowFixMe[cannot-spread-inexact]
    <Switch
      name={name}
      variant="compact"
      checked={checked}
      onChange={handleChange}
      disabled={disabled}
      {...extraProps}
    >
      {children}
    </Switch>
  );
}
